import styled from 'styled-components'
import media from 'styled-media-query'
import { Toolbar as MuiToolbar, AppBar as MuiAppBar } from '@material-ui/core'
import { PRIMARY } from '../../shared/styles/colors'

export const AppBar = styled(MuiAppBar)`
  &.MuiAppBar-colorPrimary {
    color: #121a3d;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 6px 6px #00000027;
  }
`

export const Toolbar = styled(MuiToolbar)`
  &.MuiToolbar-root {
    background-color: #fff;
    color: ${PRIMARY};
    justify-content: space-between;
    align-items: center;
    padding: 18px 0;
    box-sizing: border-box;
    height: 56px;
    max-width: 1012px;

    ${media.greaterThan('1280px')`
			height: 88px;
      width: 1012px;
		`}
    ${media.lessThan('1280px')`
      width: 100%;
      padding: 18px 12px;
      max-width: unset;
		`}
  }
`

export const Logo = styled.div`
  flex: 1;
  cursor: pointer;
  max-height: 86px;

  @media (max-width: 1279px) {
    justify-content: center;
    display: flex;
    max-height: 54px;
  }
  svg {
    width: 49%;
    @media (min-width: 1280px) {
      width: 193px;
    }
  }
`
